if (!customElements.get('countdown-timer')) {
  const SECONDS_PER_DAY = 86400;
  const SECONDS_PER_HOUR = 3600;
  const SECONDS_PER_MINUTE = 60;

  const pad = (value) => String(value).padStart(2, '0');

  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.endTime = new Date(this.dataset.end).getTime();
      if (Number.isNaN(this.endTime)) {
        this.hidden = true;
        return;
      }

      this.hideOnEnd = this.dataset.hideOnEnd === 'true';
      this.endMessage = this.querySelector('.countdown-timer__end');
      this.units = Object.fromEntries(
        [...this.querySelectorAll('[data-unit]')].map((node) => [node.dataset.unit, node])
      );

      if (this.tick()) {
        this.intervalId = setInterval(() => this.tick(), 1000);
      }
    }

    disconnectedCallback() {
      clearInterval(this.intervalId);
    }

    tick() {
      const remaining = this.endTime - Date.now();
      if (remaining <= 0) {
        this.finish();
        return false;
      }

      const seconds = Math.floor(remaining / 1000);
      this.units.days.textContent = pad(Math.floor(seconds / SECONDS_PER_DAY));
      this.units.hours.textContent = pad(Math.floor((seconds % SECONDS_PER_DAY) / SECONDS_PER_HOUR));
      this.units.minutes.textContent = pad(Math.floor((seconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE));
      this.units.seconds.textContent = pad(seconds % SECONDS_PER_MINUTE);
      return true;
    }

    finish() {
      clearInterval(this.intervalId);
      if (this.hideOnEnd || !this.endMessage?.textContent.trim()) {
        this.hidden = true;
        return;
      }
      this.classList.add('is-ended');
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
